export default [{
    path: '/customForm/:uuid/:user_id',
    name: 'customForm',
    meta: {
      layout: 'empty'
    },
    component: () => import('@/views/dynamicForm/crm-dynamic-form')
  }]
